
import * as types from '../../constant';


 const initialState = {
    isLoading: false,
    error: null,
    isSuccessful: false,
    data: []
  };

const getTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TEMPLATES_START:
      return { ...state, isLoading: true, error: null };
    case types.GET_TEMPLATES_SUCCESS:
      return { ...state,  isLoading: false, isSuccessful: true , data: action.payload};
    case types.GET_TEMPLATES_FAIL:
      return { ...state, error: action.payload, isLoading: false };
    case types.GET_TEMPLATES_CLEANUP:
      return { ...state, error: null, isLoading: false, isSuccessful: false };
    default:
      return state;
  }
};

export default getTemplatesReducer;
